import React from "react";
import { Props } from "./types";

function AddRowAfterIcon({ className }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="16"
      height="16"
    >
      <rect x="3" y="3" width="18" height="12" rx="1" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <line x1="9" y1="3" x2="9" y2="15" />
      <line x1="15" y1="3" x2="15" y2="15" />
      <line x1="12" y1="17" x2="12" y2="23" />
      <line x1="9" y1="20" x2="15" y2="20" />
    </svg>
  );
}

export { AddRowAfterIcon };
